import React from 'react';

class BackToTop extends React.Component {
    render() {
        return (
            <div className="btn-back_to_top">
                <span className="ti-arrow-up"></span>
            </div>
        )
    }
}

export default BackToTop;